import * as ActionTypes from '../constants/ActionTypes'

// **************************************************************************************************************
export const appInitialized = (initParams) => ({

    type: ActionTypes.APP_INITIALIZED,
    payload: initParams

})








/** WEBPACK FOOTER **
 ** ./src/actions/AppInit.js
 **/